import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { colors } from 'constants/colors';
const Button = ({ isActive, children, className, link, noShadow, type = 'blue', borderColor, fontColor, disabled, onClick, }) => {
    return (React.createElement(Container, { backgroundColor: type, className: className, "data-active": isActive, noShadow: noShadow, borderColor: borderColor, fontColor: fontColor, onClick: onClick, disabled: disabled }, link ? React.createElement(StyledLink, { to: link }, children) : children));
};
const styleByColor = {
    white: `${colors.ffffff}`,
    blue: `${colors['3269f5']}`,
    red: `${colors['ff0000']}`,
    green: `${colors['35d46a']}`,
    gray: `${colors['e0e0e0']}`,
    transparent: 'transparent',
};
const Container = styled.button `
  appearance: none;
  color: ${(props) => props.disabled
    ? colors.dimGray
    : props.fontColor
        ? props.fontColor
        : props.backgroundColor === 'white'
            ? colors.dodgerBlue
            : colors.white};
  cursor: pointer;
  padding: 0 28px;
  outline: none;
  background-color: ${(props) => props.disabled ? styleByColor.gray : styleByColor[props.backgroundColor]};
  border-radius: 8px;
  box-shadow: ${(props) => (props.noShadow ? 'none' : `0 2px 20px -6px ${colors['0544666e']}`)};
  height: 88px;
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'initial')};
  ${(props) => props.borderColor
    ? `border: 2px solid ${props.disabled
        ? styleByColor.gray
        : styleByColor[props.borderColor]}`
    : 'border: none'};
  ${(props) => props.backgroundColor === 'white' && `border: 2px solid ${colors.d1dee5}`};

  &[data-active='false'] {
    pointer-events: none;
    background-color: ${colors['cccfd9']};
    color: ${colors.white};
    box-shadow: none;
  }
`;
export const EvaluationOpeningButton = styled(Button) `
  margin-top: 25px;
`;
const StyledLink = styled(Link) `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: inherit;
`;
export default Button;
